import {Component, ViewChild} from '@angular/core';
import {DataGridView, DataGridViewCollumn} from "../../../Componente/DataGridView";
import {GeraeteEdit} from "../../Controlls/EditViews/GeraeteEdit";
import {PopUpView} from "../../../Componente/PopUpView";
import {GeraeteModell} from '../../../Api/DcoApi/Admin/AdminClasses2';
import {ReportAdminEdit} from '../Popups/report-admin-edit/report-admin-edit';

@Component({
  selector: 'app-report-admin-list',
  imports: [
    DataGridView,
    DataGridViewCollumn,
    GeraeteEdit,
    PopUpView,
    ReportAdminEdit
  ],
  templateUrl: './report-admin-list.html',
  styleUrl: './report-admin-list.css',
})
export class ReportAdminList {
  @ViewChild('Grid') childComponent!: DataGridView<GeraeteModell>;

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }
}
